/* eslint-disable no-redeclare */
/* eslint-disable eqeqeq */
/* eslint-disable block-scoped-var */
/* eslint-disable no-cond-assign */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
import Resizer from 'react-image-file-resizer';
import validator from 'validator';

export const resizeFile = (file, minSize = 300, maxSize = 1380) =>
  new Promise(resolve => {
    Resizer.imageFileResizer(
      file,
      maxSize,
      maxSize,
      'JPEG',
      100,
      0,
      uri => {
        resolve(uri);
      },
      'blob',
      minSize,
      minSize
    );
  });

export const isValidUrl = url => {
  return validator.isURL(url);
};

export const isValidEmail = email => {
  return validator.isEmail(email);
};

export const isValidCnpj = cnpj => {
  var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  var c = String(cnpj).replace(/[^\d]/g, '');

  if (c.length !== 14) return false;

  if (/0{14}/.test(c)) return false;

  for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
  if (c[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

  for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
  if (c[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

  return true;
};

export const isValidCpf = cpf => {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf === '') return false;
  // Elimina CPFs invalidos conhecidos
  if (
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  )
    return false;
  // Valida 1o digito
  let add = 0;
  for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i), 10) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(9), 10)) return false;
  // Valida 2o digito
  add = 0;
  for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i), 10) * (11 - i);
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(10), 10)) return false;
  return true;
};
